export default {
  GAMIFICATION: {
    name: 'Gamification_by_business_group',
    traffic_type: 'business-group',
  },
  WELLNESS: {
    name: 'DC-2430-feature-toggle-activities-routes',
    traffic_type: 'business-group',
  },
  REMOTE_THERAPY: {
    name: 'DC-2899-remote-therapy',
    traffic_type: 'business-group',
  },
  WELLNESS_THERAPIST: {
    name: 'DC-2922-therapist-wellness',
    traffic_type: 'business-group',
  },
  ADD_PLAYER: {
    name: 'DC-2892-add-player',
    traffic_type: 'business-group',
  },
  NEW_GROUP_AND_CONCURRENT: {
    name: 'DC-3490-group-and-concurrent',
    traffic_type: 'business-group',
  },
  KEYCLOAK_AUTH: {
    name: 'keycloak-auth',
    traffic_type: 'annonymous',
  },
};
